import { gql } from '@apollo/client';
import type { SerializedReseller, SerializedTemplate, User } from '@enmon/commons/lib/tools';

export const GET_TEMPLATE_DATA_LIST = gql`
  query getTemplateData($user: ID) {
    templates(filters: { reseller: { users: { id: { eq: $user } } } }) {
      data {
        id
        attributes {
          name
          updatedAt
          reseller {
            data {
              id
              attributes {
                default_template {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export interface TemplatesVariables {
  user?: User['id'];
}

// assuming your data-flattening keeps these at top-level; keep updatedAt optional
export type TemplatesDataItem = Pick<SerializedTemplate, 'id' | 'name'> & {
  updatedAt?: string | null;
  reseller: Pick<SerializedReseller, 'id'> & {
    default_template: Pick<SerializedTemplate, 'id' | 'name'>;
  };
};

export interface TemplatesDataList {
  templates: {
    data: TemplatesDataItem[];
  };
}
